<template>
    <div class="background">
        <div class="inputForm">
            <van-row>白条开通二维码</van-row>
            <van-row style="margin-top: 0.5rem;">
                <img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NZf7dr1.png" width="75%"/>
            </van-row>
            <van-row style="font-size: 1.2rem;">此二维码用于开通白条并且购物</van-row>
        </div>

        <div class="inputForm">
            <div style="text-align:center; margin: 0.5rem 0;">
                <van-field v-model="query.orderId" type="number" label="订单号" placeholder="请输入订单号" style="font-size: 1.5rem;" />
                <van-button type="danger" size="normal" @click="simpleJobOrderDeclare" class="declareButton">上报订单</van-button>
            </div>

            <div style="font-size: 1rem; margin-top: 1rem;">
                温馨提示<br/>
                二维码已经转链加密了，不要二次转链，否则后台无数据。<br/>
                只限白条新用户下单。京东新用户请勿做任何形式京东首购！否则会没有数据！！<br/>
                做单当天必须提交订单号报单，延期提交无效！
            </div>
        </div>

        <div class="inputForm">
            （报单数据查询，开始结束时间必填，最多只返回100条）
            <van-field
                    v-model="titleTimeStart"
                    placeholder="选择开始时间" readonly="readonly"
                    @click="dateShowStart = true"
            />
            <van-field
                    v-model="titleTime"
                    placeholder="选择结束时间" readonly="readonly"
                    @click="dateShow = true"
            />
            <div class="table-box" v-if="declareData.rows&&declareData.rows.length>0">
                <van-row>
                    <van-col span="13">报单时间</van-col>
                    <van-col span="11">订单号</van-col>
                </van-row>
                <van-row v-for="(row,index) in declareData.rows" :key="row.id">
                    <van-col span="13">
                        {{row.gmtCreate|parseTime('{y}-{m}-{d} {h}:{i}:{s}')}}
                    </van-col>
                    <van-col span="11">{{row.orderId}}</van-col>
                </van-row>
            </div>
            <van-popup v-model="dateShowStart" position="bottom">
                <van-datetime-picker v-model="currentDateStart" type="datetime" @cancel="handleCancel"
                                     @confirm="handleStartDateConfirm"/>
            </van-popup>
            <van-popup v-model="dateShow" position="bottom">
                <van-datetime-picker v-model="currentDate" type="datetime" @cancel="handleCancel"
                                     @confirm="handleEndDateConfirm"/>
            </van-popup>
        </div>
    </div>
</template>

<script>
    import mainAPI from '@/api/main';
    import pvuvAPI from '@/api/pvuv';

    export default {
        data() {
            return {
                query: {
                    jobId: this.$route.query.jobId,
                    traderId: this.$route.query.traderId,
                    jobLinkUpPid: this.$route.query.pid,
                    orderId: '',
                },
                dateShow: false,
                currentDate: new Date(),
                titleTime: null,
                dateShowStart: false,
                titleTimeStart: null,
                currentDateStart: new Date(),
                declareData: {}
            }
        },
        methods: {
            simpleJobOrderDeclare() {
                if (!this.query.orderId) {
                    this.$toast("请输入正确的订单号");
                    return;
                }
                mainAPI.simpleJobOrderDeclare(this.query).then(() => {
                    this.$toast("上报成功");
                    this.query.orderId = '';
                }).catch(() => {
                });
            },
            handleCancel() {
                this.dateShow = false;
                this.dateShowStart = false;
            },
            //开始时间
            handleStartDateConfirm() {
                this.dateShowStart = false;
                this.titleTimeStart = this.timeFormat(this.currentDateStart);
                this.queryDetail();
            },
            //结束时间
            handleEndDateConfirm() {
                this.dateShow = false;
                this.titleTime = this.timeFormat(this.currentDate);
                this.queryDetail();
            },
            timeFormat(datetime) { // 时间格式化 2019-09-08
                var year = datetime.getFullYear();
                var month = (datetime.getMonth() + 1) < 10 ? "0" + (datetime.getMonth() + 1) : (datetime.getMonth() + 1);
                var date = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
                var hour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime.getHours();
                var minute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
                var second = datetime.getSeconds() < 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
                return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
            },
            queryDetail() {
                if (!this.query.jobId || !this.query.traderId) {
                    this.$toast("链接有误");
                }

                if (this.titleTime && this.titleTimeStart) {
                    this.$toast.loading({forbidClick: true});
                    let queryObj = {};
                    queryObj.queryStartDate = this.titleTimeStart;
                    queryObj.queryEndDate = this.titleTime;
                    queryObj.traderId = this.query.traderId;
                    queryObj.jobId = this.query.jobId;
                    queryObj.jobLinkUpPid = this.query.jobLinkUpPid;
                    queryObj.limit = 100;

                    mainAPI.getJobOrderDeclarePage(queryObj).then((result) => {
                        this.declareData = result.data;
                        this.$toast.clear()
                    })
                }
            },
        },
        created() {
        },
        mounted() {
            pvuvAPI.addPv("baiTiaoShopping/declare2", this.query.traderId).then((result) => {
            });
        }
    }

</script>

<style lang="scss" scoped>
    .background {
        background: url('http://jho2o.oss-cn-beijing.aliyuncs.com/test/2NgGPcfF.png') no-repeat;
        background-size: 100% 100%;
        height: 90rem;
        padding-top: 10rem;
        text-align: center;
    }

    .inputForm {
        background-color: white;
        width: 85%;
        margin: 0 auto;
        padding: 0.8rem 0.5rem 0.5rem 0.5rem;
        border: 2px solid red;
    }

    .declareButton {
        width: 15rem;
        font-size: 1.5rem;
        font-weight: bold;
        color: #FFFFFF;
        margin-top: 0.5rem;
    }

</style>
